import { render, staticRenderFns } from "./UpdateTag.vue?vue&type=template&id=54b525c2&scoped=true"
import script from "./UpdateTag.vue?vue&type=script&lang=js"
export * from "./UpdateTag.vue?vue&type=script&lang=js"
import style0 from "./UpdateTag.vue?vue&type=style&index=0&id=54b525c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b525c2",
  null
  
)

export default component.exports